/* ===========================================================
   Merchloop Essential Store
   Search, filters, sort, a quiet details line on each card, and a
   Quick add dialog that opens in frame. All product and variant data
   comes from window.MLEssential, emitted by ml-essential-chips, so the
   dialog renders instantly with no network round trip.
   =========================================================== */
(function () {
  'use strict';

  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL', '4XL', '5XL', '6XL'];
  var SIZE_ALIAS = {
    XSMALL: 'XS', SMALL: 'S', MEDIUM: 'M', LARGE: 'L',
    XLARGE: 'XL', XXLARGE: 'XXL', XXXLARGE: 'XXXL'
  };

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function handleFromHref(href) {
    if (!href) return '';
    var m = href.match(/\/products\/([^?#/]+)/);
    return m ? m[1] : '';
  }

  function sizeRank(value, index) {
    var key = String(value).toUpperCase().replace(/[\s._-]/g, '');
    if (SIZE_ALIAS[key]) key = SIZE_ALIAS[key];
    var i = SIZE_ORDER.indexOf(key);
    return i >= 0 ? i : 500 + index;
  }

  function sortSizes(list) {
    return list
      .map(function (s, i) { return { s: s, r: sizeRank(s, i) }; })
      .sort(function (a, b) { return a.r - b.r; })
      .map(function (x) { return x.s; });
  }

  function optionsOf(variants) {
    var colors = [];
    var sizes = [];
    variants.forEach(function (v) {
      if (v[1] && colors.indexOf(v[1]) < 0) colors.push(v[1]);
      if (v[2] && sizes.indexOf(v[2]) < 0) sizes.push(v[2]);
    });
    return { colors: colors, sizes: sortSizes(sizes) };
  }

  /* Essential store products are almost always named "<Customer> <Product>",
     so the first line of every card repeats the brand already in the hero.
     Strip the shared leading words from the card heading only; the full name
     stays on the product page and in the title attribute. */
  function sharedPrefixWordCount(titles) {
    if (titles.length < 3) return 0;
    var split = titles.map(function (t) { return t.trim().split(/\s+/); });
    var shortest = split.reduce(function (m, w) { return Math.min(m, w.length); }, 99);
    var max = Math.min(5, shortest - 1);
    var n = 0;
    while (n < max) {
      var word = (split[0][n] || '').toLowerCase();
      if (!word) break;
      var hits = 0;
      for (var i = 0; i < split.length; i++) {
        if ((split[i][n] || '').toLowerCase() === word) hits++;
      }
      if (hits / split.length < 0.8) break;
      n++;
    }
    return n;
  }

  function trimHeadings(headings) {
    var titles = headings.map(function (h) { return h.textContent.trim(); });
    var n = sharedPrefixWordCount(titles);
    if (!n) return;
    var prefix = titles[0].trim().split(/\s+/).slice(0, n).join(' ');
    if (prefix.length < 4) return;
    var lower = prefix.toLowerCase();
    headings.forEach(function (h) {
      var full = h.textContent.trim();
      if (full.toLowerCase().indexOf(lower) !== 0) return;
      var rest = full.slice(prefix.length).replace(/^[\s\-–—:,|]+/, '').trim();
      if (rest.length < 3) return;
      h.setAttribute('title', full);
      h.textContent = rest;
    });
  }

  /* ---------------- cart ---------------- */

  function refreshCartChrome(res) {
    if (!res || !res.sections) return;
    Object.keys(res.sections).forEach(function (id) {
      if (id.indexOf('cart-notification') === 0) return;
      var target = document.getElementById(id);
      if (!target) return;
      var doc = new DOMParser().parseFromString(res.sections[id], 'text/html');
      var src = doc.querySelector('.shopify-section') || doc.body;
      target.innerHTML = src.innerHTML;
    });
  }

  function addToCart(variantId, btn, note, restLabel, onDone) {
    var cn = document.querySelector('cart-notification');
    var sections = [];
    try {
      if (cn && cn.getSectionsToRender) {
        sections = cn.getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) { sections = []; }

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    if (sections.length) {
      fd.append('sections', sections.join(','));
      fd.append('sections_url', window.location.pathname);
    }

    if (note) note.textContent = '';
    btn.disabled = true;
    btn.classList.add('is-busy');
    btn.textContent = 'Adding';

    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (res && res.status) {
          if (note) note.textContent = res.description || res.message || 'Could not add that one.';
          btn.disabled = false;
          btn.textContent = restLabel;
          return;
        }
        refreshCartChrome(res);
        btn.classList.add('is-added');
        btn.textContent = 'Added to cart';
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = restLabel;
          btn.disabled = false;
          if (onDone) onDone();
        }, 1400);
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        if (note) note.textContent = 'Something went wrong. Try again.';
        btn.disabled = false;
        btn.textContent = restLabel;
      });
  }

  /* ---------------- quick add dialog ---------------- */

  var QA = null;

  function ensureDialog() {
    if (QA) return QA;
    var d = document.createElement('dialog');
    d.className = 'ml-qa';
    d.innerHTML =
      '<button type="button" class="ml-qa__close" aria-label="Close">&times;</button>' +
      '<div class="ml-qa__inner">' +
        '<div class="ml-qa__head">' +
          '<span class="ml-qa__thumb"><img alt=""></span>' +
          '<span class="ml-qa__meta">' +
            '<span class="ml-qa__title"></span>' +
            '<span class="ml-qa__price"></span>' +
          '</span>' +
        '</div>' +
        '<div class="ml-qa__body"></div>' +
        '<button type="button" class="ml-ord__add ml-qa__add"></button>' +
        '<p class="ml-ord__note ml-qa__note"></p>' +
        '<a class="ml-qa__link" href="#">View full product details</a>' +
      '</div>';
    document.body.appendChild(d);

    d.querySelector('.ml-qa__close').addEventListener('click', function () { closeDialog(); });
    /* Click on the backdrop, which is the dialog element itself outside the panel. */
    d.addEventListener('click', function (e) { if (e.target === d) closeDialog(); });
    d.addEventListener('close', function () {
      document.documentElement.classList.remove('ml-qa-open');
    });
    QA = d;
    return d;
  }

  function closeDialog() {
    if (!QA) return;
    if (QA.open) QA.close();
    document.documentElement.classList.remove('ml-qa-open');
  }

  function openQuickAdd(info, url, imgSrc, priceText, displayTitle) {
    var d = ensureDialog();
    if (!d.showModal) { window.location.href = url; return; }

    var variants = info.v || [];
    var opts = optionsOf(variants);
    var colors = opts.colors;
    var sizes = opts.sizes;

    var thumb = d.querySelector('.ml-qa__thumb img');
    thumb.src = imgSrc || '';
    thumb.alt = info.t || '';
    d.querySelector('.ml-qa__title').textContent = displayTitle || info.t || '';
    d.querySelector('.ml-qa__price').textContent = priceText || '';
    d.querySelector('.ml-qa__link').setAttribute('href', url);

    var body = d.querySelector('.ml-qa__body');
    var addBtn = d.querySelector('.ml-qa__add');
    var note = d.querySelector('.ml-qa__note');
    body.innerHTML = '';
    note.textContent = '';
    addBtn.className = 'ml-ord__add ml-qa__add';
    addBtn.disabled = false;

    var state = { color: null, size: null };
    for (var i = 0; i < variants.length; i++) {
      if (variants[i][3]) { state.color = variants[i][1] || null; break; }
    }
    if (!state.color && colors.length) state.color = colors[0];
    if (sizes.length === 1) state.size = sizes[0];

    function match(size) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (colors.length && v[1] !== state.color) continue;
        if (sizes.length && v[2] !== size) continue;
        return v;
      }
      return null;
    }

    var colorRow = null;
    var colorName = null;
    if (colors.length > 1) {
      var cLabel = document.createElement('p');
      cLabel.className = 'ml-qa__label';
      cLabel.innerHTML = 'Color <span class="ml-qa__chosen"></span>';
      body.appendChild(cLabel);
      colorName = cLabel.querySelector('.ml-qa__chosen');

      colorRow = document.createElement('div');
      colorRow.className = 'ml-ord__colors';
      colors.forEach(function (name) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ml-ord__color';
        b.setAttribute('aria-label', name);
        b.dataset.color = name;
        var img = info.m && info.m[name];
        if (img) b.style.backgroundImage = 'url("' + img + '")';
        b.addEventListener('click', function () {
          state.color = name;
          state.size = sizes.length === 1 ? sizes[0] : null;
          if (img) thumb.src = img;
          render();
        });
        colorRow.appendChild(b);
      });
      body.appendChild(colorRow);
    }

    var sizeRow = null;
    if (sizes.length > 1) {
      var sLabel = document.createElement('p');
      sLabel.className = 'ml-qa__label';
      sLabel.textContent = 'Size';
      body.appendChild(sLabel);
      sizeRow = document.createElement('div');
      sizeRow.className = 'ml-ord__sizes';
      body.appendChild(sizeRow);
    }

    function render() {
      if (colorRow) {
        Array.prototype.forEach.call(colorRow.children, function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.color === state.color));
        });
      }
      if (colorName) colorName.textContent = state.color || '';

      if (sizeRow) {
        sizeRow.innerHTML = '';
        sizes.forEach(function (size) {
          var v = match(size);
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ml-ord__size';
          b.textContent = size;
          if (!v || !v[3]) {
            b.disabled = true;
            b.setAttribute('aria-label', size + ', sold out');
          } else {
            b.setAttribute('aria-pressed', String(size === state.size));
            b.addEventListener('click', function () { state.size = size; render(); });
          }
          sizeRow.appendChild(b);
        });
      }

      var chosen = match(state.size);
      if (sizes.length > 1 && !state.size) {
        addBtn.disabled = true;
        addBtn.textContent = 'Select a size';
      } else if (!chosen || !chosen[3]) {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold out';
      } else {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to cart';
      }
    }

    addBtn.onclick = function () {
      var chosen = match(state.size);
      if (!chosen || !chosen[3]) return;
      addToCart(chosen[0], addBtn, note, 'Add to cart', closeDialog);
    };

    render();
    document.documentElement.classList.add('ml-qa-open');
    d.showModal();
    var first = body.querySelector('button:not([disabled])') || addBtn;
    if (first) first.focus();
  }

  /* ---------------- card details ---------------- */

  function summaryFor(colors, sizes) {
    var bits = [];
    if (colors.length > 1) bits.push(colors.length + ' colors');
    if (sizes.length > 1) {
      bits.push('Sizes ' + sizes[0] + ' to ' + sizes[sizes.length - 1]);
    } else if (sizes.length === 1) {
      bits.push('Size ' + sizes[0]);
    }
    return bits.join(' · ');
  }

  function buildCard(card, info, url) {
    var variants = info && info.v;
    if (!variants || !variants.length) return;

    var container = card.querySelector('.product-card__container');
    if (!container || container.querySelector('.ml-ord')) return;

    var opts = optionsOf(variants);
    var sellable = variants.some(function (v) { return v[3]; });

    var wrap = document.createElement('div');
    wrap.className = 'ml-ord';

    var summary = document.createElement('p');
    summary.className = 'ml-ord__summary';
    summary.textContent = summaryFor(opts.colors, opts.sizes);
    wrap.appendChild(summary);

    var actions = document.createElement('div');
    actions.className = 'ml-ord__actions';

    var view = document.createElement('a');
    view.className = 'ml-ord__view';
    view.href = url;
    view.textContent = 'View product';
    actions.appendChild(view);

    if (sellable) {
      var quick = document.createElement('button');
      quick.type = 'button';
      quick.className = 'ml-ord__quick';

      /* A product with a single variant has nothing to choose, so the dialog
         would be an empty step. Add it straight to the cart instead. */
      if (variants.length === 1) {
        quick.textContent = 'Add';
        quick.setAttribute('aria-label', 'Add ' + (info.t || 'this item') + ' to cart');
        quick.addEventListener('click', function () {
          addToCart(variants[0][0], quick, null, 'Add');
        });
      } else {
        quick.textContent = 'Quick add';
        quick.addEventListener('click', function () {
          /* Read these at click time: the heading has been trimmed of the
             shared customer prefix by then, so the dialog matches the card. */
          var img = card.querySelector('.product-card__image img');
          var priceEl = card.querySelector('.price');
          var head = card.querySelector('.product-card__heading');
          openQuickAdd(
            info,
            url,
            img ? img.currentSrc || img.src : '',
            priceEl ? priceEl.textContent.trim() : '',
            head ? head.textContent.trim() : ''
          );
        });
      }
      actions.appendChild(quick);
    }

    wrap.appendChild(actions);
    container.appendChild(wrap);
    card.classList.add('ml-ord-ready');
  }

  /* ---------------- page ---------------- */

  function init() {
    var data = window.MLEssential;
    var grid = document.querySelector('.grid.collection');
    if (!grid) return;

    var items = Array.prototype.filter.call(grid.children, function (el) {
      return el.querySelector && el.querySelector('.product-card');
    });
    if (!items.length) return;

    var lookup = (data && data.products) || {};

    items.forEach(function (item, i) {
      var card = item.querySelector('.product-card');
      var link = item.querySelector('.product-card__heading[href], .product-card__image[href], a[href*="/products/"]');
      var href = link ? link.getAttribute('href') : '';
      var info = lookup[handleFromHref(href)];

      item.setAttribute('data-ml-cat', (info && info.c) || '');
      item.setAttribute('data-ml-fit', (info && info.f) || '');
      item.setAttribute('data-ml-price', (info && info.p) || 0);
      item.setAttribute('data-ml-order', i);
      item.setAttribute('data-ml-title', (info && info.t) || (link ? link.textContent.trim() : ''));

      if (info) buildCard(card, info, href);
    });

    trimHeadings(Array.prototype.slice.call(grid.querySelectorAll('.product-card__heading')));

    var bar = document.querySelector('[data-ml-ess-shopbar]');
    if (!bar) return;

    var chips = Array.prototype.slice.call(bar.querySelectorAll('[data-ml-chip]'));
    var sel = bar.querySelector('[data-ml-select]');
    var sortSel = bar.querySelector('[data-ml-sort-select]');
    var countEl = bar.querySelector('[data-ml-count]');
    var empty = document.querySelector('[data-ml-empty]');
    var searchWrap = bar.querySelector('[data-ml-search]');
    var searchInput = searchWrap && searchWrap.querySelector('input');
    var searchClear = searchWrap && searchWrap.querySelector('.ml-ess-search__clear');
    var label = (countEl && countEl.getAttribute('data-ml-count')) || 'items';

    var slotA = { dim: 'cat', val: 'all' };
    var slotB = { dim: sel ? sel.getAttribute('data-ml-dim') : 'fit', val: 'all' };
    var query = '';

    if (chips.length) slotA.dim = chips[0].getAttribute('data-ml-dim') || 'cat';

    function matches(item, slot) {
      if (slot.val === 'all') return true;
      return item.getAttribute('data-ml-' + slot.dim) === slot.val;
    }

    function apply() {
      var shown = 0;
      items.forEach(function (item) {
        var ok = matches(item, slotA) && matches(item, slotB);
        if (ok && query) {
          var hay = (item.getAttribute('data-ml-title') + ' ' + item.getAttribute('data-ml-cat')).toLowerCase();
          ok = hay.indexOf(query) > -1;
        }
        item.classList.toggle('ml-ess-hidden', !ok);
        if (ok) shown++;
      });
      if (countEl) {
        countEl.textContent = shown + ' ' + (shown === 1 ? label.replace(/s$/, '') : label);
      }
      if (empty) empty.classList.toggle('is-on', shown === 0);
    }

    function sort(mode) {
      var list = items.slice();
      if (mode === 'price-asc') {
        list.sort(function (a, b) { return (+a.getAttribute('data-ml-price')) - (+b.getAttribute('data-ml-price')); });
      } else if (mode === 'price-desc') {
        list.sort(function (a, b) { return (+b.getAttribute('data-ml-price')) - (+a.getAttribute('data-ml-price')); });
      } else if (mode === 'title-asc') {
        list.sort(function (a, b) {
          return a.getAttribute('data-ml-title').localeCompare(b.getAttribute('data-ml-title'));
        });
      } else {
        list.sort(function (a, b) { return (+a.getAttribute('data-ml-order')) - (+b.getAttribute('data-ml-order')); });
      }
      var frag = document.createDocumentFragment();
      list.forEach(function (el) { frag.appendChild(el); });
      grid.appendChild(frag);
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        slotA.val = chip.getAttribute('data-ml-val') || 'all';
        chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
        apply();
      });
    });

    if (sel) {
      sel.addEventListener('change', function () { slotB.val = sel.value || 'all'; apply(); });
    }
    if (sortSel) {
      sortSel.addEventListener('change', function () { sort(sortSel.value); });
    }

    if (searchInput) {
      var timer = null;
      searchInput.addEventListener('input', function () {
        searchWrap.classList.toggle('is-filled', searchInput.value.length > 0);
        clearTimeout(timer);
        timer = setTimeout(function () {
          query = searchInput.value.trim().toLowerCase();
          apply();
        }, 120);
      });
      if (searchClear) {
        searchClear.addEventListener('click', function () {
          searchInput.value = '';
          searchWrap.classList.remove('is-filled');
          query = '';
          apply();
          searchInput.focus();
        });
      }
    }

    var chipRow = bar.querySelector('.ml-ess-chips');
    function markChipScroll() {
      if (!chipRow) return;
      chipRow.classList.toggle('is-scroll', chipRow.scrollWidth > chipRow.clientWidth + 2);
    }
    markChipScroll();
    window.addEventListener('resize', markChipScroll);
    if (chipRow) chipRow.addEventListener('scroll', function () {
      chipRow.classList.toggle('is-scroll', chipRow.scrollWidth - chipRow.scrollLeft > chipRow.clientWidth + 2);
    }, { passive: true });

    /* Shadow under the toolbar once it sticks, so it reads as a layer. */
    var tools = document.querySelector('.ml-ess-tools-section') || document.querySelector('.ml-ess-tools');
    if (tools) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          tools.classList.toggle('is-stuck', tools.getBoundingClientRect().top <= 0);
          ticking = false;
        });
      }, { passive: true });
    }

    apply();
  }

  ready(init);
})();
